<template>
  <tr class="rsd-field-row">
    <td>{{ label }}</td>
    <td>
      <div class="rsd-row-wrapper">
        <div class="rsd-row-wrapper__control">
          <slot />
        </div>
        <button
          v-if="detail"
          type="button"
          class="rsd-detail-toggle"
          :class="{
            active: open,
            'rsd-detail-toggle--readonly': !editable,
          }"
          :title="commentTitle"
          :aria-expanded="open ? 'true' : 'false'"
          @click="open = !open"
        >
          <i
            :class="open ? 'bi bi-dash-lg' : 'bi bi-plus-lg'"
            aria-hidden="true"
          />
        </button>
      </div>
      <div
        v-if="detail"
        class="rsd-detail-inline"
        :class="{ expanded: open }"
      >
        <input
          v-model="localComment"
          type="text"
          class="form-control rsd-detail-input"
          :placeholder="commentPlaceholder"
          :disabled="!editable"
          :readonly="!editable"
          data-rsd-comment="1"
          :data-rsd-comment-key="commentKey || undefined"
        >
      </div>
    </td>
  </tr>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  label: { type: String, required: true },
  detail: { type: Boolean, default: true },
  comment: { type: String, default: '' },
  /** Ключ в model.field_comments — для flush перед Save. */
  commentKey: { type: String, default: '' },
  commentTitle: { type: String, default: 'Comment' },
  commentPlaceholder: { type: String, default: 'Comment…' },
  editable: { type: Boolean, default: false },
})

const emit = defineEmits(['update:comment'])

const open = ref(Boolean(String(props.comment || '').trim()))
const localComment = ref(String(props.comment || ''))

watch(
  () => props.comment,
  value => {
    const next = String(value || '')
    if (next !== localComment.value) {
      localComment.value = next
    }
    if (next.trim()) {
      open.value = true
    }
  },
  { immediate: true }
)

watch(localComment, value => {
  if (!props.editable) {
    return
  }
  emit('update:comment', value)
})
</script>
